var Enum = Enum || {};

Enum.ORIGIN_SYSTEM = {
    MEEDY_PROTECT: "MEEDY_PROTECT"
}
